export const IMPSOCIALGOALAction = {
    AddSocialGoal: "ADDSOCIALGOAL",
    RemoveSocialGoal: "REMOVESOCIALGOAL",
}

// const udpatedSocialGoals = [ {
//        Id: 0,
//        fkPCPGoalTypeId: 0,
//        fkGoalMasterDataId: 0,
//        goalMasterData: { Id: 0, GoalText: "" }
//    }];

   const udpatedSocialGoals = [];

   const ImportSocialGoalsReducer = (updtGoals = udpatedSocialGoals, actions) => {
       switch (actions.type) {
           case IMPSOCIALGOALAction.AddSocialGoal:
             //  return { ...updtGoals, ...actions.payload };
                        updtGoals.push(actions.payload);
                        return updtGoals;
           case IMPSOCIALGOALAction.RemoveSocialGoal:
                        updtGoals=[];
                        return updtGoals;

            default:
                    return updtGoals;
       }
    }
    export default ImportSocialGoalsReducer;